import { router } from '@inertiajs/vue3'

let loaded = false
let storedPixelId = null

export function loadMetaPixelScript() {
  return new Promise((resolve) => {
    if (loaded) { resolve(); return }
    loaded = true

    if (!window.fbq.loaded) {
      const script = document.createElement('script')
      script.async = true
      script.src = 'https://connect.facebook.net/en_US/fbevents.js'
      script.onload = resolve
      script.onerror = resolve
      document.head.appendChild(script)
      window.fbq.loaded = true
    } else {
      resolve()
    }

    if (storedPixelId) {
      window.fbq('init', storedPixelId)
      window.fbq('track', 'PageView')
    }
  })
}

export default {
  install(app, options = {}) {
    if (import.meta.env.SSR) {
      app.config.globalProperties.$fbq = () => {}
      app.provide('fbq', () => {})
      return
    }

    const { enabled = true, pixel_id, autoLoad = true } = options
    if (!enabled || !pixel_id) {
      app.config.globalProperties.$fbq = () => {}
      app.provide('fbq', () => {})
      return
    }

    storedPixelId = pixel_id

    if (!window.fbq) {
      const fbq = function (...args) {
        if (fbq.callMethod) {
          fbq.callMethod.apply(fbq, args)
          return
        }

        fbq.queue.push(args)
      }

      if (!window._fbq) {
        window._fbq = fbq
      }

      fbq.push = fbq
      fbq.loaded = false
      fbq.version = '2.0'
      fbq.queue = []
      window.fbq = fbq
    }

    if (autoLoad) {
      const loadWhenIdle = () => {
        if (typeof window.requestIdleCallback === 'function') {
          window.requestIdleCallback(() => {
            loadMetaPixelScript()
          }, { timeout: 5000 })
        } else {
          setTimeout(() => loadMetaPixelScript(), 5000)
        }
      }

      loadWhenIdle()
    }

    router.on('navigate', () => {
      if (window.fbq) {
        window.fbq('track', 'PageView')
      }
    })

    app.config.globalProperties.$fbq = (...args) => window.fbq?.(...args)
    app.provide('fbq', (...args) => window.fbq?.(...args))
  },
}
